import React from 'react';
import * as Store from '@apply/store';
import {
    RentalPropertyReview,
    NonRentalPropertyReview,
    BridgePropertyReview,
    SubSectionHeader,
    DemographicsReview,
} from '@apply/ui';
import { LoanType } from '@apply/constants';

export interface PropertiesReviewProps {
    properties: Store.PropertiesStore.Types.PropertiesState;
    loanType: LoanType;
    apiId?: string;
    printMode?: boolean;
    formCompleted: boolean;
    token: string;
    collapsable: boolean;
}

export const PropertiesReview: React.FC<PropertiesReviewProps> = ({
    properties,
    loanType,
    apiId,
    printMode = false,
    formCompleted,
    token,
    collapsable,
}) => {
    const rentalTypes = [LoanType.BuildRent, LoanType.Rental];

    const isRental = (loanType: LoanType) => {
        if (rentalTypes.includes(loanType)) {
            return true;
        } else {
            return false;
        }
    };

    const propertyReview = (property: Store.PropertiesStore.Types.Property, index: number) => {
        if (isRental(loanType)) {
            return (
                <RentalPropertyReview
                    key={property.guid}
                    loanType={loanType}
                    property={property}
                    index={index}
                    apiId={apiId}
                    formCompleted={formCompleted}
                    token={token}
                    printMode={printMode}
                    collapsable={collapsable}
                />
            );
        } else {
            if (loanType == LoanType.Bridge) {
                return (
                    <BridgePropertyReview
                        key={property.guid}
                        property={property}
                        loanType={loanType}
                        index={index}
                        apiId={apiId}
                        printMode={printMode}
                        formCompleted={formCompleted}
                        token={token}
                        collapsable={collapsable}
                    />
                );
            } else {
                return (
                    <NonRentalPropertyReview
                        key={property.guid}
                        property={property}
                        loanType={loanType}
                        index={index}
                        apiId={apiId}
                        printMode={printMode}
                        formCompleted={formCompleted}
                        token={token}
                        collapsable={collapsable}
                    />
                );
            }
        }
    };

    return (
        <>
            <SubSectionHeader
                title='Property'
                printMode={printMode}
                formCompleted={formCompleted}
            />
            {properties?.items?.map((property, index) => (
                <React.Fragment key={index}>
                    {propertyReview(property, index)}
                    {printMode && <DemographicsReview address={property.address} />}
                </React.Fragment>
            ))}
        </>
    );
};
